import { ENDPOINT } from 'api/endPoints/getSPITrend';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IScoreCardsWrapperProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { MEDIUM, SMALL } from 'components/Dashboards/Reporting/reportingConfig';

export const spiTrend: IHashmapItemWithCustomProps<IScoreCardsWrapperProps> = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            medium: MEDIUM,
        },
        widgetInitialSize: SMALL,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: false,
    },
    title: 'SPI Trend',
    id: 'spi-trend',
    componentKey: 'spiTrend',
    endpoint: ENDPOINT,
};
